module.exports = __webpack_public_path__ + "static/media/06_after.46a45f40.jpg";